<div class="form-group">
  <label
    *ngIf="labelTranslateKey.length > 0"
    class="label d-flex align-items-center gap-6"
    [ngClass]="{ required: isInputControlRequired() }"
    [for]="labelTranslateKey">
    {{ labelTranslateKey | translate }}
    <ng-container *ngIf="labelLinkConfig">
      <a [routerLink]="labelLinkConfig.routerLink">({{ labelLinkConfig.textTranslateKey | translate }})</a>
    </ng-container>
    <i
      *ngIf="tooltipTranslateKey"
      class="ph ph-info icon-size-16"
      placement="top"
      ngbTooltip="{{ tooltipTranslateKey | translate }}"></i>
  </label>
  <ng-select
    appFieldsetDisabled
    class="ng-select choices"
    appendTo="body"
    [formControl]="inputControl"
    [id]="labelTranslateKey"
    [items]="options"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [clearable]="clearable"
    [placeholder]="getPlaceholder() | translate"
    [notFoundText]="'APPLICATION.FORM.multiSelect:notFoundText' | translate"
    [groupBy]="groupBy"
    [multiple]="multiple"
    [closeOnSelect]="!multiple"
    [readonly]="readonly"
    [searchFn]="searchByField != null ? customSearchFn : null"
    [virtualScroll]="true">
    <ng-template
      ng-optgroup-tmp
      let-item="item">
      <span [title]="getDisplayGroupText(item) | translate">
        {{ getDisplayGroupText(item) | translate }}
      </span>
    </ng-template>

    <ng-template
      let-item="item"
      ng-option-tmp
      ng-label-tmp>
      <span [title]="getDisplayText(item) | translate">
        {{ getDisplayText(item) | translate }}
      </span>
    </ng-template>
  </ng-select>
  <app-validation-message
    [field]="inputControl"
    displayName="{{ labelTranslateKey | translate | lowercase }}"></app-validation-message>
</div>
